import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from "./router";
import Meta from 'vue-meta';

Vue.use(Meta, {
  attribute: 'data-vue-meta', // vmid를 사용하기 위한 옵션
  tagIDKeyName: 'vmid', // 변화시키는 구분 값
});

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
